module.exports = __webpack_public_path__ + "static/img/zync.42de92b.png";


//////////////////
// WEBPACK FOOTER
// ./static/zync.png
// module id = zjpL
// module chunks = 11